// extracted by mini-css-extract-plugin
export default {"section":"form_section-module___section___f7fda260","content":"form_section-module___content___b2383d32"};